import { Environment } from 'relay-runtime';
import ShopWithCeoAddMutation from '../../../mutationsModern/User/ShopWithCeoAddMutation';
import { handleExitEvent } from './handleExitEvent';
import { handleShopEvent } from './handleShopEvent';
import { GROUP_FUNDRAISER_CONSTANTS } from '../../Layouts/GroupFundraiser/GroupFundraiserConstants';

export function shopWithCeo({
  ceoCustomUrl,
  trinityDealerId,
  shoppingWithCeoUser,
  eventId,
  environment,
  preventEventExit,
}: {
  environment: Environment;
  ceoCustomUrl: string;
  trinityDealerId: string;
  eventId: string;
  shoppingWithCeoUser?: any;
  preventEventExit?: boolean;
}) {
  if (!(ceoCustomUrl || trinityDealerId || eventId)) return;

  // check if dealerId is an integer
  if (trinityDealerId && !/^\d+$/.test(trinityDealerId)) {
    return;
  }

  // If the customer is already shopping with this ceo,
  // return early since we dont need to make any changes.
  // This will leave any event attached in this case too.
  if (shoppingWithCeoUser) {
    if (ceoCustomUrl && ceoCustomUrl === shoppingWithCeoUser.customUrl) {
      return;
    }
    if (
      trinityDealerId &&
      trinityDealerId === shoppingWithCeoUser.trinityDealerId
    ) {
      return;
    }

    // don't let ONEHOPE replace any CE
    if (
      shoppingWithCeoUser.trinityDealerId &&
      trinityDealerId ===
        GROUP_FUNDRAISER_CONSTANTS.ONEHOPE_DEALER_ID.toString()
    ) {
      return;
    }
  }

  // The customer will be assigned a new ceo to shop with.
  // Remove any event and refresh the navbar by a cartHotSwap
  ShopWithCeoAddMutation.commit({
    environment,
    ceoCustomUrl,
    eventId,
    trinityDealerId,
    onCompleted: () => {
      if (eventId) {
        handleShopEvent({ eventId, environment });
      } else if (!preventEventExit) {
        handleExitEvent({ environment });
      }
    },
    onError: (trans: any) => {
      console.log('TRANS error: ', trans);
    },
  });
}
